(function () {
  'use strict';

  if (window.__mtProductCarouselBootstrapped) return;
  window.__mtProductCarouselBootstrapped = true;

  var MOBILE_CAROUSEL_MQ = '(max-width: 749px)';
  var MOBILE_PAGE_SIZE = 4;

  function uniqueHandles(handles) {
    var seen = Object.create(null);
    return handles.filter(function (handle) {
      if (!handle || seen[handle]) return false;
      seen[handle] = true;
      return true;
    });
  }

  function readRecentlyViewedHandles() {
    var cookieValue = '';

    if (typeof window.Cookies !== 'undefined' && typeof window.Cookies.get === 'function') {
      cookieValue = window.Cookies.get('shopify_recently_viewed') || '';
    } else {
      var match = document.cookie.match(/(?:^|;\s*)shopify_recently_viewed=([^;]*)/);
      cookieValue = match ? decodeURIComponent(match[1]) : '';
    }

    if (!cookieValue) return [];
    return cookieValue.split(/\s+/).filter(Boolean);
  }

  function extractSectionHtml(html) {
    if (!html || !html.trim()) return '';
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var sectionEl = temp.querySelector('.shopify-section');
    return sectionEl ? sectionEl.innerHTML : html;
  }

  class MtProductCarousel {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('.mt-product-carousel__viewport');
      this.track = root.querySelector('[data-mt-carousel-track]');
      this.navs = Array.from(root.querySelectorAll('[data-mt-carousel-nav]'));
      this.prevBtns = Array.from(root.querySelectorAll('[data-mt-carousel-prev]'));
      this.nextBtns = Array.from(root.querySelectorAll('[data-mt-carousel-next]'));
      this.items = [];
      this.itemStep = 0;
      this.scrollStep = 0;
      this.maxScroll = 0;
      this.destroyed = false;
      this.mobileMq = window.matchMedia(MOBILE_CAROUSEL_MQ);

      if (!this.track) {
        this.destroyed = true;
        return;
      }

      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onLayoutChange = this.onLayoutChange.bind(this);

      this.refreshItems();
      this.bindControls();
    }

    isMobileGrid() {
      return this.mobileMq.matches;
    }

    getScroller() {
      return this.isMobileGrid() && this.viewport ? this.viewport : this.track;
    }

    refreshItems() {
      this.items = Array.from(this.track.querySelectorAll('[data-mt-carousel-item]'));
      this.measure();
      this.updateUI();
    }

    bindControls() {
      this.prevBtns.forEach(function (btn) {
        btn.addEventListener('click', this.onPrev);
      }, this);
      this.nextBtns.forEach(function (btn) {
        btn.addEventListener('click', this.onNext);
      }, this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.viewport) {
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      }
      window.addEventListener('resize', this.onResize);

      if (this.mobileMq.addEventListener) {
        this.mobileMq.addEventListener('change', this.onLayoutChange);
      } else if (this.mobileMq.addListener) {
        this.mobileMq.addListener(this.onLayoutChange);
      }
    }

    getTrackGap() {
      var styles = window.getComputedStyle(this.track);
      return parseFloat(styles.columnGap || styles.gap || '0') || 0;
    }

    measure() {
      if (!this.items.length) {
        this.itemStep = 0;
        this.scrollStep = 0;
        this.maxScroll = 0;
        return;
      }

      if (this.isMobileGrid() && this.viewport) {
        var gap = this.getTrackGap();
        var viewportWidth = this.viewport.clientWidth;
        var columnWidth = Math.max(0, (viewportWidth - gap) / 2);

        this.viewport.style.setProperty('--mt-carousel-col-width', columnWidth + 'px');
        this.itemStep = columnWidth + gap;
        this.scrollStep = viewportWidth;
        this.maxScroll = Math.max(0, this.track.scrollWidth - viewportWidth);

        if (this.track.scrollLeft !== 0) {
          this.track.scrollLeft = 0;
        }

        if (viewportWidth === 0) {
          var self = this;
          window.requestAnimationFrame(function () {
            if (!self.destroyed) {
              self.measure();
              self.updateUI();
            }
          });
        }

        return;
      }

      if (this.viewport) {
        this.viewport.style.removeProperty('--mt-carousel-col-width');
      }

      var first = this.items[0];
      var gap = this.getTrackGap();
      this.itemStep = first.getBoundingClientRect().width + gap;
      this.scrollStep = this.itemStep;
      this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    scrollByStep(delta) {
      if (!this.scrollStep) return;
      var scroller = this.getScroller();
      var target = scroller.scrollLeft + delta * this.scrollStep;
      scroller.scrollTo({ left: target, behavior: 'smooth' });
    }

    onPrev() {
      if (this.prevBtns.length && this.prevBtns[0].classList.contains('is-disabled')) return;
      this.scrollByStep(-1);
    }

    onNext() {
      if (this.nextBtns.length && this.nextBtns[0].classList.contains('is-disabled')) return;
      this.scrollByStep(1);
    }

    onScroll() {
      this.updateUI();
    }

    onResize() {
      this.measure();
      this.updateUI();
    }

    onLayoutChange() {
      this.track.scrollLeft = 0;
      if (this.viewport) this.viewport.scrollLeft = 0;
      this.measure();
      this.updateUI();
    }

    updateUI() {
      var scroller = this.getScroller();
      var left = scroller.scrollLeft;
      var max = this.maxScroll || 0;
      var atStart = left <= 1;
      var atEnd = max <= 1 ? true : left >= max - 1;
      var needsNav;

      if (this.isMobileGrid()) {
        needsNav = this.items.length > MOBILE_PAGE_SIZE && max > 1;
      } else {
        needsNav = this.items.length > 1 && max > 1;
      }

      this.navs.forEach(function (nav) {
        nav.hidden = !needsNav;
      });

      this.prevBtns.forEach(function (btn) {
        btn.classList.toggle('is-disabled', atStart);
      });
      this.nextBtns.forEach(function (btn) {
        btn.classList.toggle('is-disabled', atEnd);
      });
    }

    destroy() {
      this.prevBtns.forEach(function (btn) {
        btn.removeEventListener('click', this.onPrev);
      }, this);
      this.nextBtns.forEach(function (btn) {
        btn.removeEventListener('click', this.onNext);
      }, this);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.viewport) this.viewport.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);

      if (this.mobileMq.removeEventListener) {
        this.mobileMq.removeEventListener('change', this.onLayoutChange);
      } else if (this.mobileMq.removeListener) {
        this.mobileMq.removeListener(this.onLayoutChange);
      }

      this.destroyed = true;
    }
  }

  var instances = new Map();

  function initCarousel(root) {
    if (!root || instances.has(root)) return instances.get(root);

    var instance = new MtProductCarousel(root);
    if (!instance.destroyed) {
      instances.set(root, instance);
      return instance;
    }

    return null;
  }

  function destroyCarousel(root) {
    var instance = instances.get(root);
    if (!instance) return;
    instance.destroy();
    instances.delete(root);
  }

  function revealSection(section) {
    section.hidden = false;
  }

  function hideSection(section) {
    section.hidden = true;
  }

  function loadFeaturedProduct(section) {
    if (section.dataset.mtFeaturedLoaded === 'true') return;
    if (!section.hasAttribute('data-base-url')) return;

    var track = section.querySelector('[data-mt-carousel-track]');
    var baseUrl = section.dataset.baseUrl;
    var productId = section.dataset.productId;
    var cardsSectionId = section.dataset.cardsSectionId;
    var limit = section.dataset.productLimit || '8';
    var intent = section.dataset.recommendationIntent || 'related';

    if (!track || !baseUrl || !productId || !cardsSectionId) return;

    if (track.querySelector('[data-mt-carousel-item]')) {
      section.dataset.mtFeaturedLoaded = 'true';
      revealSection(section);
      initCarousel(section);
      return;
    }

    var url =
      baseUrl +
      '?section_id=' +
      encodeURIComponent(cardsSectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(limit) +
      '&intent=' +
      encodeURIComponent(intent);

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var content = extractSectionHtml(html);
        section.dataset.mtFeaturedLoaded = 'true';

        if (!content.trim()) {
          hideSection(section);
          return;
        }

        track.insertAdjacentHTML('beforeend', content);

        if (!track.querySelector('[data-mt-carousel-item]')) {
          hideSection(section);
          return;
        }

        revealSection(section);
        var instance = initCarousel(section);
        if (instance) instance.refreshItems();
      })
      .catch(function () {
        section.dataset.mtFeaturedLoaded = 'true';
        hideSection(section);
      });
  }

  function fetchRecentlyViewedCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=mt-carousel-card')
      .then(function (response) {
        if (!response.ok) throw new Error('Product not found');
        return response.text();
      })
      .then(function (html) {
        if (!html || html.indexOf('mt-product-carousel__item') === -1) return '';
        return html.trim();
      });
  }

  function loadRecentlyViewed(section) {
    if (section.dataset.mtRecentlyLoaded === 'true' || section.dataset.mtRecentlyLoading === 'true') {
      return;
    }

    section.dataset.mtRecentlyLoading = 'true';

    var track = section.querySelector('[data-mt-carousel-track]');
    if (!track) {
      delete section.dataset.mtRecentlyLoading;
      return;
    }

    var limit = parseInt(section.dataset.productLimit || '8', 10);
    var excludeHandle = section.dataset.excludeHandle || '';
    var handles = uniqueHandles(
      readRecentlyViewedHandles().filter(function (handle) {
        return handle && handle !== excludeHandle;
      })
    );

    if (limit > 0) {
      handles = handles.slice(0, limit);
    }

    if (!handles.length) {
      section.dataset.mtRecentlyLoaded = 'true';
      delete section.dataset.mtRecentlyLoading;
      hideSection(section);
      return;
    }

    var index = 0;
    var loaded = 0;

    function moveAlong() {
      if (index >= handles.length) {
        section.dataset.mtRecentlyLoaded = 'true';
        delete section.dataset.mtRecentlyLoading;

        if (loaded === 0) {
          hideSection(section);
          return;
        }

        revealSection(section);
        var instance = initCarousel(section);
        if (instance) instance.refreshItems();
        return;
      }

      var handle = handles[index];
      index += 1;

      fetchRecentlyViewedCard(handle)
        .then(function (html) {
          if (html) {
            track.insertAdjacentHTML('beforeend', html);
            loaded += 1;
          }
        })
        .catch(function () {
          /* skip invalid handles */
        })
        .finally(function () {
          moveAlong();
        });
    }

    moveAlong();
  }

  function initSection(section) {
    if (section.hasAttribute('data-mt-featured-product')) {
      if (section.querySelector('[data-mt-carousel-item]')) {
        revealSection(section);
        initCarousel(section);
        return;
      }
      loadFeaturedProduct(section);
      return;
    }

    if (section.hasAttribute('data-mt-recently-viewed')) {
      loadRecentlyViewed(section);
      return;
    }

    if (section.querySelector('[data-mt-carousel-item]')) {
      revealSection(section);
      initCarousel(section);
    }
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-mt-product-carousel]').forEach(initSection);
  }

  function destroy(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-mt-product-carousel]').forEach(destroyCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
